<template>
  <span>
    {{ getTranslation() }}
  </span>
</template>

<script>
export default {
  name: 'ExperienceText',
  props: {
    years: { type: Number, required: true }
  },
  computed: {
    locale() {
      return this.$vuetify.lang.current;
    },
    yearForms() {
      const raw = this.$vuetify.lang.t('$vuetify.view.psychDescrModal.yearForms');
      if (typeof raw !== 'string' || !raw.length) {
        return ['', '', '']; // або ['',''] якщо хочеш
      }
      return raw.split('|').map(s => s.trim());
    }
  },
  methods: {
    getYearWord(n) {
      const forms = this.yearForms;
      if (this.locale === 'uk' || this.locale === 'ru') {
        const mod10 = n % 10;
        const mod100 = n % 100;
        if (mod10 === 1 && mod100 !== 11) return forms[0] || '';
        if ([2,3,4].includes(mod10) && ![12,13,14].includes(mod100)) return forms[1] || '';
        return forms[2] || '';
      }
      return n === 1 ? forms[0] || '' : forms[1] || '';
    },
    getTranslation() {
      let str = this.$vuetify.lang.t('$vuetify.view.psychDescrModal.experience_with_years');
      if (!str) return '';
      str = str.replace('{count}', this.years);
      str = str.replace('{year}', this.getYearWord(this.years));
      return str;
    }
  }
};
</script>